import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

/** Native select: best picker on phones, and accessible for free. */
export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(function Select(
  { className, ...rest },
  ref,
) {
  return (
    <select
      ref={ref}
      className={cn('min-h-11 w-full rounded-control border border-line bg-surface px-3 text-base text-fg focus:border-accent', className)}
      {...rest}
    />
  );
});
